// extracted by mini-css-extract-plugin
export var actionButton = "_dl-0";
export var attachmentLine = "_dl-1";
export var fileInput = "_dl-2";
export var fileUploadWrapper = "_dl-4";
export var footer = "_dl-3";
export var modalContent = "_dl-5";
export var paperclip = "_dl-6";
export var quillEditor = "_dl-7";